import React, { useState, useEffect } from 'react';
import DOMPurify from "dompurify";
import axios from "axios";

function Home() {
    const [pageContentAbout, setPageContentAbout] = useState([]);
    const [moduleContent1, setModuleContent1] = useState([]);
    const [moduleContent2, setModuleContent2] = useState([]);
    const [moduleContent3, setModuleContent3] = useState([]);
    const [moduleContent4, setModuleContent4] = useState([]);
    const [moduleContent5, setModuleContent5] = useState([]);
    const [moduleContent6, setModuleContent6] = useState([]);
    const [moduleContent7, setModuleContent7] = useState([]);
    const [moduleContent8, setModuleContent8] = useState([]);
    const [moduleContent9, setModuleContent9] = useState([]);
    const [pageContentService, setPageContentService] = useState([]);
    const [pageContentHome, setPageContentHome] = useState([]);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSPage/GetPageContentById/248`)
            .then((response) => {
                setPageContentAbout(response.data);
            });
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSPage/GetPageContentById/216`)
            .then((response) => {
                setPageContentService(response.data);
            });
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSPage/GetPageContentById/129`)
            .then((response) => {
                setPageContentHome(response.data);
            });
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSModule/GetPageModuleContentById/1`)
            .then((response) => {
                setModuleContent1(response.data);
            });
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSModule/GetPageModuleContentById/2`)
            .then((response) => {
                setModuleContent2(response.data);
            });
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSModule/GetPageModuleContentById/3`)
            .then((response) => {
                setModuleContent3(response.data);
            });
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSModule/GetPageModuleContentById/4`)
            .then((response) => {
                setModuleContent4(response.data);
            });
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSModule/GetPageModuleContentById/5`)
            .then((response) => {
                setModuleContent5(response.data);
            });
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSModule/GetPageModuleContentById/6`)
            .then((response) => {
                setModuleContent6(response.data);
            });
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSModule/GetPageModuleContentById/7`)
            .then((response) => {
                setModuleContent7(response.data);
            });
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSModule/GetPageModuleContentById/8`)
            .then((response) => {
                setModuleContent8(response.data);
            });
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSModule/GetPageModuleContentById/9`)
            .then((response) => {
                setModuleContent9(response.data);
            });
    }, []);

    const leftContentHTML = DOMPurify.sanitize(pageContentAbout.pgS_T_OTHERPAGECONTENT2);
    const rightImageHTML = DOMPurify.sanitize(pageContentAbout.pgS_T_PAGECONTENT);
    const mContent1 = DOMPurify.sanitize(moduleContent1.pmC_V_MODULECONTENT);
    const mContent2 = DOMPurify.sanitize(moduleContent2.pmC_V_MODULECONTENT);
    const mContent3 = DOMPurify.sanitize(moduleContent3.pmC_V_MODULECONTENT);
    const mContent4 = DOMPurify.sanitize(moduleContent4.pmC_V_MODULECONTENT);
    const mContent5 = DOMPurify.sanitize(moduleContent5.pmC_V_MODULECONTENT);
    const mContent6 = DOMPurify.sanitize(moduleContent6.pmC_V_MODULECONTENT);
    const mContent7 = DOMPurify.sanitize(moduleContent7.pmC_V_MODULECONTENT);
    const mContent8 = DOMPurify.sanitize(moduleContent8.pmC_V_MODULECONTENT);
    const mContent9 = DOMPurify.sanitize(moduleContent9.pmC_V_MODULECONTENT);
    const leftContentServiceHTML = DOMPurify.sanitize(pageContentService.pgS_T_OTHERPAGECONTENT2);
    const leftImageHomeHTML = DOMPurify.sanitize(pageContentHome.pgS_T_OTHERPAGECONTENT2);
    const rightContentHomeHTML = DOMPurify.sanitize(pageContentHome.pgS_T_PAGECONTENT);

    return (
        <div>
            <div class="slider-container">
                <div class="slider-control left inactive"></div>
                <div class="slider-control right"></div>
                <ul class="slider-pagi"></ul>
                <div class="slider">
                    <div class="slide slide-0 active" style={{ backgroundImage: "url('/assets/img/slide1.jpg')" }}>
                        <div class="slide__bg"></div>
                        <div class="slide__content">
                            <div class="slide__overlay">
                            </div>
                            <div class="slide__text">
                                <h1 class="slide__text-heading">{moduleContent7.pmC_V_MODULENAME}</h1>
                                <div class="hidden-mobile">
                                    <div dangerouslySetInnerHTML={{ __html: mContent7 }} />
                                </div>
                                <a href="/services" class="btn btn-default">our services</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <svg id="curveUp" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="none" fill="#fff">
                <path d="M0 100 C 20 0 50 0 100 100 Z" />
            </svg>
            <section id="services-index" class="bg-pattern" data-bottom-top="background-position: 0px 70%,99% 70%;"
                data-top-bottom="background-position: 0px -50%,99% -50%;">
                <div class="container">
                    <div class="section-heading">
                        <h2>Our Services</h2>
                    </div>
                    <div class="col-md-10 col-md-offset-1 text-center">
                        <div dangerouslySetInnerHTML={{ __html: leftContentServiceHTML }} />
                    </div>
                </div>
                <div class="container-fluid margin1">
                    <div class="col-md-10 col-md-offset-1">
                        <div id="owl-services" class="owl-carousel">
                            <div class="col-xs-12">
                                <div class="box_icon">
                                    <div class="icon" dangerouslySetInnerHTML={{ __html: mContent1 }} />                                        
                                    {/* <div class="image">
                                        <img src="/assets/img/service1.jpg" class="img-responsive" alt="" />
                                    </div>
                                    <div class="info">
                                        <h4>Exotic Pets</h4>
                                        <p>Nulla vel metus scelerisque ante sollicitudinlorem ipsuet commodo. Cras purus odio, vestibulum in vulputate a Imperdiet interdum donec eget metus auguen unc vel lorem.</p>
                                        <a class="btn" href="services-single.html">Read More</a>
                                    </div> */}                                    
                                </div>
                            </div>
                            <div class="col-xs-12">
                                <div class="box_icon">
                                    <div class="icon" dangerouslySetInnerHTML={{ __html: mContent2 }} />
                                </div>
                            </div>
                            <div class="col-xs-12">
                                <div class="box_icon">
                                    <div class="icon" dangerouslySetInnerHTML={{ __html: mContent3 }} />                                        
                                </div>
                            </div>
                            <div class="col-xs-12">
                                <div class="box_icon">
                                    <div class="icon" dangerouslySetInnerHTML={{ __html: mContent8 }} />                                        
                                </div>
                            </div>
                            <div class="col-xs-12">
                                <div class="box_icon">
                                    <div class="icon" dangerouslySetInnerHTML={{ __html: mContent9 }} />                                        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="about-index" class="bg-lightcolor1">
                <div class="container">
                    <div class="section-heading text-center">
                        <h2>About Us</h2>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-lg-7 text-center">
                            <div dangerouslySetInnerHTML={{ __html: leftContentHTML }} />
                            <div class="panel-group" id="accordion">
                                <div class="panel">
                                    <div class="panel-heading">
                                        <h5 class="panel-title">
                                            <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne">{moduleContent4.pmC_V_MODULENAME}</a>
                                        </h5>
                                    </div>
                                    <div id="collapseOne" class="panel-collapse collapse in">
                                        <div class="panel-body">
                                            <div dangerouslySetInnerHTML={{ __html: mContent4 }} />
                                        </div>
                                    </div>
                                </div>
                                <div class="panel">
                                    <div class="panel-heading">
                                        <h5 class="panel-title">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">{moduleContent5.pmC_V_MODULENAME}</a>
                                        </h5>
                                    </div>
                                    <div id="collapseTwo" class="panel-collapse collapse">
                                        <div class="panel-body">
                                            <div dangerouslySetInnerHTML={{ __html: mContent5 }} />
                                        </div>
                                    </div>
                                </div>
                                <div class="panel">
                                    <div class="panel-heading">
                                        <h5 class="panel-title">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseThree">{moduleContent6.pmC_V_MODULENAME}</a>
                                        </h5>
                                    </div>
                                    <div id="collapseThree" class="panel-collapse collapse">
                                        <div class="panel-body">
                                            <div dangerouslySetInnerHTML={{ __html: mContent6 }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-5">
                            <div className='img-container' dangerouslySetInnerHTML={{ __html: rightImageHTML }} />
                        </div>
                    </div>
                </div>
            </section>
            <section id="reviews">
                <div class="container">
                    <div class="section-heading text-center">
                        <h2>Clients Reviews</h2>
                    </div>                    
                    <div class="col-md-12">
                        <div id="owl-reviews" class="owl-carousel margin1">
                            <div class="review">
                                <div class="col-xs-12">
                                    <div class="review-caption">
                                        <h5>Sue Shei</h5>
                                        <div class="small-heading">
                                            Dog Lover
                                        </div>
                                        <blockquote>
                                            Patatemp dolupta orem retibusam qui commolu
                                            Fusce mollis imperdiet interdum donec eget metus auguen unc vel mauris ultricies,
                                            vest ibulum orci eget, viverra.
                                        </blockquote>
                                    </div>
                                    <div class="review-profile-image">
                                        <img src="/assets/img/review1.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div class="review">
                                <div class="col-xs-12">
                                    <div class="review-caption">
                                        <h5>Jonas Smith</h5>
                                        <div class="small-heading">
                                            Cat Specialist
                                        </div>
                                        <blockquote>
                                            Patatemp dolupta orem retibusam qui commolu
                                            Fusce mollis imperdiet interdum donec eget metus auguen unc vel mauris ultricies,
                                            vest ibulum orci eget, viverra.
                                        </blockquote>
                                    </div>
                                    <div class="review-profile-image">
                                        <img src="/assets/img/review2.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div class="review">
                                <div class="col-xs-12">
                                    <div class="review-caption">
                                        <h5>Maria Silva</h5>
                                        <div class="small-heading">
                                            Exotic Birds Vet
                                        </div>
                                        <blockquote>
                                            Patatemp dolupta orem retibusam qui commolu
                                            Fusce mollis imperdiet interdum donec eget metus auguen unc vel mauris ultricies,
                                            vest ibulum orci eget, viverra.
                                        </blockquote>
                                    </div>
                                    <div class="review-profile-image">
                                        <img src="/assets/img/review3.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div class="review">
                                <div class="col-xs-12">
                                    <div class="review-caption">
                                        <h5>Lou Lou</h5>
                                        <div class="small-heading">
                                            Veterinarian
                                        </div>
                                        <blockquote>
                                            Patatemp dolupta orem retibusam qui commolu
                                            Fusce mollis imperdiet interdum donec eget metus auguen unc vel mauris ultricies,
                                            vest ibulum orci eget, viverra.
                                        </blockquote>
                                    </div>
                                    <div class="review-profile-image">
                                        <img src="/assets/img/review4.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div class="review">
                                <div class="col-xs-12">
                                    <div class="review-caption">
                                        <h5>James Doe</h5>
                                        <div class="small-heading">
                                            Pet Lover
                                        </div>
                                        <blockquote>
                                            Patatemp dolupta orem retibusam qui commolu
                                            Fusce mollis imperdiet interdum donec eget metus auguen unc vel mauris ultricies,
                                            vest ibulum orci eget, viverra.
                                        </blockquote>
                                    </div>
                                    <div class="review-profile-image">
                                        <img src="/assets/img/review5.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="callout container-fluid" style={{ padding: "0 0 50px" }}>
                <div class="row-fluid">
                    <div class="col-lg-8 col-md-12 no-padding" data-start="right: 20%;"
                        data-center="right:0%;">
                        <div className='img-container' dangerouslySetInnerHTML={{ __html: leftImageHomeHTML }} />
                    </div>
                    <div class="callout-box col-lg-6 col-lg-offset-6 bg-darkcolor" data-start="left: 20%;"
                        data-center="left:0%;">
                        <div dangerouslySetInnerHTML={{ __html: rightContentHomeHTML }} />
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Home;
